import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import useQueryString from '@hooks/useQueryString';
import { makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const EmptyCard = () => {
  const { emptyCardContainer } = useStyles();
  const history = useHistory();
  const { query } = useQueryString<{
    searchKeyword?: string;
    searchType?: string;
  }>();

  const handleClick = () => {
    history.push('/request');
  };
  const isSearched =
    query?.searchKeyword?.length !== 0 || query?.searchType !== 'ALL';
  return (
    <div className={emptyCardContainer}>
      <div className="empty-card-text">
        <CustomizedTypography align="center" color="textSecondary">
          {isSearched
            ? `검색 결과가 없습니다.`
            : `제조 내역이 없습니다. 새로운 견적을 요청하여 파트너와 첫번째 거래를 시작해 보세요.`}
        </CustomizedTypography>
      </div>
      {!isSearched && (
        <div>
          <CustomizedButton onClick={handleClick} size="medium">
            <i className="request-gtm-startMakeRFQ-btn">새 견적 요청하기</i>
          </CustomizedButton>
        </div>
      )}
    </div>
  );
};

export default EmptyCard;

const useStyles = makeStyles({
  emptyCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 30,
    padding: `43px 0`,
    borderRadius: 12,
    border: `1px dashed ${colorSet.gray400}`,
    background: colorSet.gray100,
    '& .empty-card-text': {
      width: 325
    }
  }
});
